export default __webpack_public_path__ + "static/media/c16.443c4b89.png";